import { useCallback, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { copyToJsBridge } from 'src/utils/jsBridge/implementation'
import { track } from 'src/utils/tracker'
import { isAppWebview } from 'src/utils/userAgent'

export function useCopy() {
  const { t } = useTranslation(['action'])
  const [copied, setCopied] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  const copy = useCallback(
    async (
      content: string,
      opts?: { enableTrackValue?: boolean; scene?: string | null },
    ) => {
      const { enableTrackValue, scene } = opts ?? {}
      try {
        if (isAppWebview()) {
          copyToJsBridge(content)
        } else {
          await window.navigator.clipboard.writeText(content)
        }
        clearTimeout(timerRef.current)
        setCopied(true)
        timerRef.current = setTimeout(() => setCopied(false), 1000)
        if (scene != null)
          track('copy_success', {
            scene,
            ...(enableTrackValue ? { value: content } : {}),
          })
      } catch (err: any) {
        toast.warn(t('action:copy-failed'))
        console.error(err)
        if (scene !== null) track('copy_failed', { scene })
      }
    },
    [t],
  )

  return [copy, copied] as const
}
